/**
 * ColumnLayout — generic two-column layout component.
 *
 * Renders an image in the left column and arbitrary children in the right column.
 * Columns are equal width on desktop (md+) and stack vertically on mobile.
 *
 * Props:
 *   image           {ReactNode}  Required. Element to render in the left column.
 *   children        {ReactNode}  Required. Content for the right column.
 *   className       {string}     Optional extra classes on the outer wrapper.
 *   imageClassName  {string}     Optional extra classes on the image column.
 *   contentClassName{string}     Optional extra classes on the content column.
 */
const ColumnLayout = ({
  image,
  children,
  className = '',
  imageClassName = '',
  contentClassName = '',
}) => {
  return (
    <div className={`flex flex-col md:flex-row gap-8 md:gap-16 items-center ${className}`}>

      {/* Left column — image */}
      <div className={`w-full md:w-1/2 flex-shrink-0 ${imageClassName}`}>
        {image}
      </div>

      {/* Right column — content */}
      <div className={`w-full md:w-1/2 ${contentClassName}`}>
        {children}
      </div>

    </div>
  );
};

export { ColumnLayout };
